import React, {useContext, useState} from "react";
import {DAMAGE_REPORT_REFERENCE_NUMBER_PARAM_NAME, getParam} from "../util/ParamUtil";
import ClayDropDown from '@clayui/drop-down';
import {ClayButtonWithIcon} from "@clayui/button";
import {CartsContext} from "../util/Context";


function isAddingToCartDisabled(product, cartsContext) {
    return product.restricted && !cartsContext.currentCart.insuranceCart;
}

const AddProductSingleButton = ({product, label, callback}) => {
    const cartsContext = useContext(CartsContext);
    const mainButtonDisabled = isAddingToCartDisabled(product, cartsContext)
    return (
        <button type="button" disabled={mainButtonDisabled} key={product.id} className={"btn btn-primary comparison-action-button"}
                onClick={() => callback(product.id)}>
            <span className="lfr-btn-label">{label}</span>
        </button>
    )
}
const AddProductSplitButton = ({product, label, callback}) => {
    const [expand, setExpand] = useState(false);
    const cartsContext = useContext(CartsContext);

    const otherCarts = product.restricted ? cartsContext.otherInsuranceCarts : cartsContext.otherCarts
    const mainButtonDisabled = isAddingToCartDisabled(product, cartsContext)
    return (
        <div className="button-split">
            <button type="button" disabled={mainButtonDisabled} key={product.id} className={"btn btn-primary comparison-action-button m-0 w-100"}
                    onClick={() => callback(product.id)}>
                <span className="lfr-btn-label">{label}</span>
            </button>
            {otherCarts?.length>0 &&
            <ClayDropDown active={expand}
                // alignmentPosition={alignmentPosition}
                className="cart-selector-dropdown"
                menuElementAttrs={{className: 'cart-selector-dropdown-menu'}}
                onActiveChange={() => setExpand(oldExpand => !oldExpand)}
                trigger={
                    <ClayButtonWithIcon spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"}
                                        symbol="plus"
                                        displayType="primary" className="btn h-100 p-0 dropdown-toggle-button"/>
                }>

                    <ul className={"list-unstyled"}>
                        {otherCarts.map(otherCart => (
                            <li key={otherCart.commerceOrderId}>
                                <button className="dropdown-item" onClick={() => callback(product.id, otherCart.commerceOrderId)}
                                        role="menuitem">
                                    {otherCart.name}
                                </button>
                            </li>
                        ))}
                    </ul>

            </ClayDropDown>
            }

        </div>
    )
}

const AddProductButton = ({product, label, callback}) => {
    if (!Liferay.ThemeDisplay.isSignedIn() || product.internal) return <span>&nbsp;</span>;
    else if (getParam(DAMAGE_REPORT_REFERENCE_NUMBER_PARAM_NAME)) return <AddProductSingleButton product={product} label={label} callback={callback}/>
    return <AddProductSplitButton product={product} label={label} callback={callback}/>

}
export default AddProductButton;